// 应用上下文
window.ttx = window.ttx || {};
ttx.context = {};

// 缓存解析结果
ttx.context._queryCache = null;

// 获取当前页面 URL query 参数对象
ttx.context.getQuery = function () {
    if (ttx.context._queryCache) return ttx.context._queryCache;
    const query = {};
    const search = window.location.search.substring(1);
    if (!search) return query;
    search.split('&').forEach(function (pair) {
        const [key, value] = pair.split('=');
        if (key) {
            query[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
        }
    });
    ttx.context._queryCache = query;
    return query;
};

// 获取单个 query 参数
ttx.context.getQueryParam = function (name) {
    return ttx.context.getQuery()[name];
};

// 设置上下文数据
ttx.context.set = function (key, value) {
    ttx.context[key] = value;
};

// 获取上下文数据
ttx.context.get = function (key) {
    return ttx.context[key];
};

// ============================================================================
// 以下为 MDF cb.context 兼容 API 补充（保留上述已有 API 不变）
//
// 上下文数据来源优先级：
//   1. ttx.rest.AppContext（标准化上下文，若 tx.rest 模块已加载）
//   2. window.jDiwork.diworkContext() / window.diworkContext()（宿主上下文）
//   3. localStorage（最后兜底）
// 所有 getter 在数据不存在时返回 undefined/null，不抛错。
// ============================================================================

// 内部：读取 localStorage（容错，浏览器禁用 localStorage 时不报错）
function _ls(key) {
    try {
        return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
        return null;
    }
}

// 内部：将值转为布尔（兼容 true/'true'/1/'1'）
function _asBool(val) {
    return val === true || val === 'true' || val === 1 || val === '1';
}

// 内部：解析 JSON 字符串为对象（容错，优先复用 ttx.utils.stringToJSON）
function _parseJSON(str, fallback) {
    if (str == null) return fallback;
    if (typeof str !== 'string') return str;
    if (ttx.utils && typeof ttx.utils.stringToJSON === 'function') {
        return ttx.utils.stringToJSON(str);
    }
    try { return JSON.parse(str); } catch (e) { return fallback; }
}

// 内部：解析 JSON 字符串为数组（容错，优先复用 ttx.utils.stringToJSONArray）
function _parseJSONArray(str, fallback) {
    if (str == null) return fallback;
    if (typeof str !== 'string') return str;
    if (ttx.utils && typeof ttx.utils.stringToJSONArray === 'function') {
        return ttx.utils.stringToJSONArray(str);
    }
    try { return JSON.parse(str); } catch (e) { return fallback; }
}

/**
 * 内部：获取上下文数据源
 * 优先返回已标准化的 ttx.rest.AppContext；其次尝试用 diworkContext 重建；
 * 若 _rebuildGlobalData 不可用则返回原始 diworkContext（下方 getter 兼容原始结构）。
 * @returns {object} 上下文对象（标准化或原始结构）
 */
ttx.context._getContext = function () {
    // 1. 优先 ttx.rest.AppContext
    if (ttx.rest && ttx.rest.AppContext) {
        return ttx.rest.AppContext;
    }
    // 2. 其次 diwork 宿主上下文
    var diworkCtx = null;
    if (window.jDiwork && typeof window.jDiwork.diworkContext === 'function') {
        try { diworkCtx = window.jDiwork.diworkContext(); } catch (e) { diworkCtx = null; }
    }
    if (!diworkCtx && typeof window.diworkContext === 'function') {
        try { diworkCtx = window.diworkContext(); } catch (e) { diworkCtx = null; }
    }
    if (diworkCtx) {
        // 尝试用 _rebuildGlobalData 标准化为 { globalization, user, tenant, yat } 结构
        if (ttx.rest && typeof ttx.rest._rebuildGlobalData === 'function') {
            return ttx.rest._rebuildGlobalData(diworkCtx) || {};
        }
        // 无标准化函数时返回原始结构，getter 内部兼容两种结构
        return diworkCtx;
    }
    return {};
};

// ----------------------------------------------------------------------------
// 租户信息
// ----------------------------------------------------------------------------

/** 友互通租户 ID */
ttx.context.getTenantId = function () {
    var ctx = ttx.context._getContext();
    return (ctx.tenant && ctx.tenant.tenantId) || ctx.tenantid || _ls('tenantId');
};

/**
 * 营销云租户 ID
 * @param {object} [viewmodel] - 可选，传入则取其 domainKey 对应的领域上下文
 * @returns {string|undefined}
 */
ttx.context.getYxyTenantId = function (viewmodel) {
    var ctx = ttx.context._getContext();
    if (viewmodel && ttx.rest && typeof ttx.rest.getAppContext === 'function') {
        ctx = ttx.rest.getAppContext(viewmodel.getDomainKey && viewmodel.getDomainKey()) || ctx;
    }
    return (ctx.tenant && ctx.tenant.yxyTenantid)
        || (ctx.ext && ctx.ext.yxyTenantId)
        || (ctx.tenant && ctx.tenant.identities && ctx.tenant.identities[0] && ctx.tenant.identities[0].yxyTenantId)
        || _ls('yxyTenantId');
};

/** 单组织 ID */
ttx.context.getOrgId = function () {
    var ctx = ttx.context._getContext();
    return (ctx.tenant && ctx.tenant.orgId) || (ctx.ext && ctx.ext.orgId) || _ls('orgId');
};

/** 默认业务单元 */
ttx.context.getDefaultOrg = function () {
    var ctx = ttx.context._getContext();
    return (ctx.tenant && ctx.tenant.defaultOrg) || (ctx.ext && ctx.ext.defaultOrg) || _ls('defaultOrg');
};

/** 是否单组织 */
ttx.context.isSingleOrg = function () {
    var ctx = ttx.context._getContext();
    return _asBool((ctx.tenant && ctx.tenant.isSingleOrg) || (ctx.ext && ctx.ext.isSingleOrg));
};

/** 是否新架构 */
ttx.context.isNewArch = function () {
    var ctx = ttx.context._getContext();
    return _asBool((ctx.tenant && ctx.tenant.newArch) || (ctx.ext && ctx.ext.newArch));
};

/** 是否财务新架构 */
ttx.context.isNewFiArch = function () {
    var ctx = ttx.context._getContext();
    return _asBool((ctx.tenant && ctx.tenant.newFiArch) || (ctx.ext && ctx.ext.n_f_f));
};

/** 产品线 */
ttx.context.getProductLine = function () {
    var ctx = ttx.context._getContext();
    return (ctx.tenant && ctx.tenant.productLine) || ctx.productLine || _ls('productLine');
};

/** 是否密集租户 */
ttx.context.isMjTenant = function () {
    var ctx = ttx.context._getContext();
    return _asBool((ctx.tenant && ctx.tenant.mj) || (ctx.ext && ctx.ext.mj));
};

// ----------------------------------------------------------------------------
// 用户信息
// ----------------------------------------------------------------------------

/** 用户 ID（友互通） */
ttx.context.getUserId = function () {
    var ctx = ttx.context._getContext();
    return (ctx.user && ctx.user.userId) || ctx.userid || _ls('userId');
};

/** 营销云用户 ID（身份 ID） */
ttx.context.getYxyUserId = function () {
    var ctx = ttx.context._getContext();
    return (ctx.user && ctx.user.identityId)
        || (ctx.ext && ctx.ext.identityId)
        || (ctx.tenant && ctx.tenant.identities && ctx.tenant.identities[0] && ctx.tenant.identities[0].id)
        || _ls('identityId');
};

/** 营销云用户 ID（别名，等同 getYxyUserId） */
ttx.context.getIdentityId = function () {
    return ttx.context.getYxyUserId();
};

/**
 * 用户类型
 * @returns {number|string|undefined} 0 企业管理员 / 1 企业人员 / 2 客户 / 3 客户子账号 / 4 商家管理员 / 5 商家的人员
 */
ttx.context.getUserType = function () {
    var ctx = ttx.context._getContext();
    var val = (ctx.user && ctx.user.userType) || ctx.userType;
    if (val == null) return _ls('userType');
    return val;
};

/** 用户名 */
ttx.context.getUserName = function () {
    var ctx = ttx.context._getContext();
    return (ctx.user && ctx.user.userName) || ctx.username || _ls('userName');
};

/** 文档 ID（当前登录身份关联的客户/供应商标识） */
ttx.context.getDocId = function () {
    var ctx = ttx.context._getContext();
    return (ctx.user && ctx.user.docId) || ctx.docId || (ctx.ext && ctx.ext.docId) || _ls('docId');
};

/** 文档类型（客户、供应商、toB、toC 等） */
ttx.context.getDocType = function () {
    var ctx = ttx.context._getContext();
    return (ctx.user && ctx.user.docType) || ctx.docType || (ctx.ext && ctx.ext.docType) || _ls('docType');
};

// ----------------------------------------------------------------------------
// 全球化信息（ttx.context.global）
// ----------------------------------------------------------------------------

// 初始化 global 对象，再挂方法
ttx.context.global = {};

/** 当前语种 */
ttx.context.global.getLocale = function () {
    var ctx = ttx.context._getContext();
    return (ctx.globalization && ctx.globalization.locale)
        || ctx.locale
        || (ctx.tenant && ctx.tenant.locale)
        || _ls('locale');
};

/** 默认语种（从语种列表中 default=true 的项取 langCode） */
ttx.context.global.getSysLocale = function () {
    var ctx = ttx.context._getContext();
    if (ctx.globalization && ctx.globalization.sysLocale) {
        return ctx.globalization.sysLocale;
    }
    // 从 multilist 计算
    var list = ttx.context.global.getMultilist();
    if (list && list.length) {
        for (var i = 0; i < list.length; i++) {
            if (list[i] && list[i].default === true) return list[i].langCode;
        }
    }
    return _ls('sysLocale');
};

/** 时区 */
ttx.context.global.getTimeZone = function () {
    var ctx = ttx.context._getContext();
    return (ctx.globalization && ctx.globalization.timezone)
        || ctx.timezone
        || (ctx.tenant && ctx.tenant.timezone)
        || _ls('timezone');
};

/** 是否多语 */
ttx.context.global.isMultilingualFlag = function () {
    var ctx = ttx.context._getContext();
    var val = (ctx.globalization && ctx.globalization.multilingualFlag);
    if (val == null) val = ctx.ext && ctx.ext.multilingualFlag;
    if (val == null) val = ctx.tenant && ctx.tenant.multilingualFlag;
    return _asBool(val);
};

/** 语种列表 */
ttx.context.global.getMultilist = function () {
    var ctx = ttx.context._getContext();
    if (ctx.globalization && ctx.globalization.multilist) {
        return ctx.globalization.multilist;
    }
    var raw = ctx.multilist || (ctx.tenant && ctx.tenant.multilist);
    return _parseJSONArray(raw, []);
};

/**
 * 数据格式（含 timezone、dateFormat、dateTimeFormat 等）
 * @returns {object}
 */
ttx.context.global.getDataFormat = function () {
    var ctx = ttx.context._getContext();
    if (ctx.globalization && ctx.globalization.dataformat) {
        return ctx.globalization.dataformat;
    }
    var raw = ctx.dataformat || (ctx.tenant && ctx.tenant.dataformat);
    return _parseJSON(raw, {});
};

/** 业务日期 */
ttx.context.global.getBusinessDate = function () {
    var ctx = ttx.context._getContext();
    return (ctx.globalization && ctx.globalization.businessDate)
        || ctx.businessDate
        || (ctx.tenant && ctx.tenant.businessDate)
        || _ls('businessDate');
};

// ----------------------------------------------------------------------------
// 业务参数
// ----------------------------------------------------------------------------

/**
 * 获取公共参数（框架初始化预加载，不发接口）
 * 委托给 ttx.rest.AppContext.getCommonOptionValue（若可用），否则返回 null（占位）。
 * @param {string} name - 参数名
 * @param {*} [query] - 额外 query
 * @returns {*}
 */
ttx.context.getCommonOptionValue = function (name, query) {
    if (ttx.rest && ttx.rest.AppContext && typeof ttx.rest.AppContext.getCommonOptionValue === 'function') {
        return ttx.rest.AppContext.getCommonOptionValue(name, query);
    }
    // 占位：后端未对接时返回 null
    return null;
};

/**
 * 获取单个业务参数
 * 委托给 ttx.rest.AppContext.getOptionValue（若可用），否则返回 null（占位）。
 * @param {string} name - 参数名
 * @param {string} [orgId] - 组织 ID
 * @param {string} [domain] - 领域
 * @param {string} [domainKey] - 领域 key
 * @param {*} [query] - 额外 query
 * @returns {*}
 */
ttx.context.getOptionValue = function (name, orgId, domain, domainKey, query) {
    if (ttx.rest && ttx.rest.AppContext && typeof ttx.rest.AppContext.getOptionValue === 'function') {
        return ttx.rest.AppContext.getOptionValue(name, orgId, domain, domainKey, query);
    }
    // 占位：后端未对接时返回 null
    return null;
};

/**
 * 获取多个业务参数
 * 委托给 ttx.rest.AppContext.getOptionValues（若可用），否则返回 null（占位）。
 * @param {string[]} name - 参数名数组
 * @param {string} [orgId] - 组织 ID
 * @param {string} [domain] - 领域
 * @param {string} [domainKey] - 领域 key
 * @param {*} [query] - 额外 query
 * @returns {*}
 */
ttx.context.getOptionValues = function (name, orgId, domain, domainKey, query) {
    if (ttx.rest && ttx.rest.AppContext && typeof ttx.rest.AppContext.getOptionValues === 'function') {
        return ttx.rest.AppContext.getOptionValues(name, orgId, domain, domainKey, query);
    }
    // 占位：后端未对接时返回 null
    return null;
};

// ----------------------------------------------------------------------------
// 其它
// ----------------------------------------------------------------------------

/**
 * 获取领域扩展属性（支持 a.b.c 穿透）
 * @param {object} viewmodel - 视图模型
 * @param {string} property - 属性路径，如 'a.b.c'
 * @returns {*}
 */
ttx.context.getExtra = function (viewmodel, property) {
    if (!viewmodel || !property) return undefined;
    var params = (typeof viewmodel.getParams === 'function' ? viewmodel.getParams() : viewmodel.params) || {};
    var extra = params.extra;
    if (extra == null) return undefined;
    var keys = String(property).split('.');
    var result = extra;
    for (var i = 0; i < keys.length; i++) {
        if (result == null) return undefined;
        result = result[keys[i]];
    }
    return result;
};

/**
 * 获取公共服务谓词（如 '<%businessDate%>'）
 * 解析 <%key%> 模板，从上下文中取对应值。
 * @param {string} name - 谓词字符串
 * @returns {*}
 */
ttx.context.getPredicateDate = function (name) {
    if (!name || typeof name !== 'string') return name;
    // 优先复用 ttx.utils.getPredicateValue
    if (ttx.utils && typeof ttx.utils.getPredicateValue === 'function') {
        return ttx.utils.getPredicateValue(name, ttx.context._getContext());
    }
    // 兜底实现
    var match = name.match(/<%([^%]*)%>/);
    if (!match) return name;
    var key = match[1];
    if (key === 'businessDate') {
        return ttx.context.global.getBusinessDate();
    }
    var ctx = ttx.context._getContext();
    return ctx[key];
};

/** 获取友互通 token（yat） */
ttx.context.getYhtAccessToken = function () {
    var ctx = ttx.context._getContext();
    return ctx.yat || (ctx.ext && ctx.ext.yht_access_token) || _ls('yat') || _ls('yht_access_token');
};

// ----------------------------------------------------------------------------
// viewmodel 级业务参数方法（挂到 BaseModel 原型，可选）
// tx.models 在 tx.context 之前加载，故此处 BaseModel 已存在
// ----------------------------------------------------------------------------
if (ttx.models && ttx.models.BaseModel && ttx.models.BaseModel.prototype) {
    /**
     * 获取单个业务参数（viewmodel 级，自动带入 domainKey）
     * @param {string} name - 参数名
     * @param {string} [orgId] - 组织 ID
     * @param {string} [domain] - 领域
     * @returns {*}
     */
    if (typeof ttx.models.BaseModel.prototype.getOptionValue !== 'function') {
        ttx.models.BaseModel.prototype.getOptionValue = function (name, orgId, domain) {
            return ttx.context.getOptionValue(name, orgId, domain, this.getDomainKey && this.getDomainKey(), this);
        };
    }
    /**
     * 获取多个业务参数（viewmodel 级，自动带入 domainKey）
     * @param {string[]} name - 参数名数组
     * @param {string} [orgId] - 组织 ID
     * @param {string} [domain] - 领域
     * @returns {*}
     */
    if (typeof ttx.models.BaseModel.prototype.getOptionValues !== 'function') {
        ttx.models.BaseModel.prototype.getOptionValues = function (name, orgId, domain) {
            return ttx.context.getOptionValues(name, orgId, domain, this.getDomainKey && this.getDomainKey(), this);
        };
    }
}
